import Button from '@components/Button';
import Column from '@components/Column';
import styled from '@emotion/styled';
import { DiscountCouponRow } from '@models/discount';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';

import DiscountItemRow from './DiscountItemRow';

interface Params {
    coupon: string;
}

declare module '@stackflow/config' {
    interface Register {
        DiscountCouponBottomSheet: Params;
    }
}

const DiscountCouponBottomSheet: ActivityComponentType<'DiscountCouponBottomSheet'> = ({ params }) => {
    const coupon: DiscountCouponRow = JSON.parse(params.coupon);
    const { orderLines } = useCalculatedRequest();
    // 단일 상품별로 쿠폰을 적용할 수 있게 표시
    const lines = orderLines
        .filter((line) => {
            if (!line.couponUsable) {
                return false;
            }
            // 적용 가능 상품만 표시
            if (coupon.applicableItemIds && coupon.applicableItemIds.length > 0) {
                return coupon.applicableItemIds.includes(line.shopItemId);
            }
            return true;
        })
        .map((line) => {
            const { quantity } = line;
            return Array.from({ length: quantity }).map((_, idx) => ({
                ...line, idx,
            }));
        }).flat();
    const { pop } = useFlow();
    return (
        <BottomSheet onOutsideClick={(e) => {
            e.preventDefault();
        }}>
            <BottomSheetContainer fullWidth>
                <Contents fullWidth spacing={8}>
                    {lines.map((line) => (
                        <DiscountItemRow key={`${line.shopItemId} ${line.idx}`}
                            coupon={coupon}
                            item={line}/>
                    ))}
                </Contents>
                <Button fullWidth onClick={pop}>완료</Button>
            </BottomSheetContainer>
        </BottomSheet>
    );
};

const Contents = styled(Column)`
    max-height: 80vh;
    overflow-y: auto;
    padding-bottom: 8px;
`;

const BottomSheetContainer = styled(Column)`
    padding: 16px 16px calc(16px + var(--safe-area-bottom));
`;

export default DiscountCouponBottomSheet;
